var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_225)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 42.5L49.0625 42.5L38.75 52.8125C37.8125 53.75 37.8125 55.3125 38.75 56.25C39.6875 57.1875 41.25 57.1875 42.1875 56.25L56.25 42.1875C56.875 41.5625 56.875 40.625 56.875 40C56.875 39.375 56.875 38.4375 56.25 37.8125L42.1875 23.75C41.25 22.8125 39.6875 22.8125 38.75 23.75C37.8125 24.6875 37.8125 26.25 38.75 27.1875L49.0625 37.5L22.5 37.5C21.25 37.5 20 38.75 20 40C20 41.25 21.25 42.5 22.5 42.5ZM40 80C62.1875 80 80 62.1875 80 40C80 17.8125 62.1875 -6.07218e-06 40 -4.13248e-06C17.8125 -2.19279e-06 2.19279e-06 17.8125 4.13248e-06 40C6.07218e-06 62.1875 17.8125 80 40 80ZM40 5C59.375 4.99999 75 20.625 75 40C75 59.375 59.375 75 40 75C20.625 75 5.00001 59.375 5 40C5 20.625 20.625 5 40 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(80 80) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circleRight.c965a59f261c5951205556ac899ae902.svg";
export { ForwardRef as ReactComponent };